import table from './table'

const events =
{
    ...table,
    helmet :
    {
        title : 'Événements' ,
        metas : []
    },
    empty  : 'Aucun événement trouvé',
    search : 'Rechercher un événement ...' ,
    title  : 'Événements'
};

export default events ;
